/* Level families whose model P(hold) Legend acts on (ladder row chips, the
 * verdict ribbon's hold-call, chart AI markers via the ladder-service lane).
 *
 * MIRRORS src/packages/mv-core/model-contract.ts FAMILIES (16, MV-4 contract)
 * minus the display-hidden set the chart pills already suppress
 * (wall / retained / session / flip — vision-draw.ts P_HIDE, structure.ts
 * MV_P_HIDE). Legend has no mv-core dependency, so this is a hand copy: keep
 * it in lockstep with the contract, and with ladder-service/model-signal-lane.ts
 * GOOD_FAMS (which derives the same set from mv-core directly).
 *
 * History: the MV-2-era list was 7 families (ma-1m/5m/15m, vwap, prior,
 * swing-15m/1h) chosen from the 2026-09-03 model-vs-FSM grading. MV-4 adds
 * `structural` (≈73% of live map rows — its headline family), ma-1w and the
 * 5m/4h/1w swings, all in its vocabulary and graded on its card. */
export const MODEL_FAMS: ReadonlySet<string> = new Set([
  'vwap', 'ma-1m', 'ma-5m', 'ma-15m', 'ma-1w', 'prior',
  'swing-5m', 'swing-15m', 'swing-1h', 'swing-4h', 'swing-1w',
  'structural',
]);
